import { DataBroker } from './DataBroker';

function GetShiurIndex(date) {
	const TodayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const FirstDate = new Date(1984, 4-1, 28);
	const DaysDiff = Math.round((TodayDate.getTime() - FirstDate.getTime()) / (1000 * 3600 * 24));

	let diff = (DaysDiff % 1017);
	return (diff == 0) ? 1017 : diff;
};

export async function GetR1(gregDate) {
	const index = GetShiurIndex(gregDate);
	let data = await DataBroker.getDataText('r/' + index);

	if (data !== null && data.indexOf('|') !== -1)
		data = data.replace("|", "\n");

	return new Promise((myResolve, myReject) => {
		if (data === null)
			myReject(DataBroker.getError());
		else
			myResolve(<div className='Rambam' dangerouslySetInnerHTML={{ __html: data }} />);
	});
};